(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
$(document).ready(function() {
    // PRE-LOADER
    function preloadImages(srcs) {
        function loadImage(src) {
            return new $.Deferred(function(def) {
                var img = new Image();

                img.onload = function() {
                    def.resolve(img);
                };

                img.onerror = img.onabort = function() {
                    def.reject(src);
                };

                img.src = src;
            }).promise();
        }

        var promises = [];

        for (var i = 0; i < srcs.length; i++) {
            promises.push(loadImage(srcs[i]));
        }

        return $.when.apply($, promises).then(function() {
            // return results as a simple array rather than as separate arguments
            return Array.prototype.slice.call(arguments);
        });
    }

    preloadImages([
        "images/ant-body.png",
        "images/bec-sixth-mug.png",
        "images/ant-body.png",
        "images/ant-head.png",
        "images/background.jpg",
        "images/bec-fifth-mug.png",
        "images/bec-fourth-mug.png",
        "images/bec-second-mug.png",
        "images/bec-third-mug.png",
        "images/bec-top-mug.png",
        "images/claires-knee.png",
        "images/cox-arm.png",
        "images/cox-body.png",
        "images/cox-head.png",
        "images/cox-legs.png",
        "images/cox.png",
        "images/end-smoke.png",
        "images/engine-scene-1.png",
        "images/engine-scene-2.png",
        "images/engine-scene-3.png",
        "images/engine.jpg",
        "images/Enigma-Polar-Express-RT-inside-only.png",
        "images/Enigma-Polar-Express-RT.jpg",
        "images/full-size.jpg",
        "images/full-train.jpg",
        "images/gareth-glow.png",
        "images/iain-arm.png",
        "images/iain-body.png",
        "images/iain-legs.png",
        "images/imran-hand.png",
        "images/imran.png",
        "images/jake-2.png",
        "images/jake-arm-1.png",
        "images/jake-arm-2.png",
        "images/jake-leg.png",
        "images/jake-shadow.png",
        "images/jake.png",
        "images/john-bottom-new.png",
        "images/john-bottom.png",
        "images/john-top-new.png",
        "images/john-top.png",
        "images/john.png",
        "images/julia-leg.png",
        "images/julia.png",
        "images/marcus-arm-new.png",
        "images/marcus-arm.png",
        "images/marcus-julia.png",
        "images/marcus-new.png",
        "images/marcus-top-new.png",
        "images/marcus-top.png",
        "images/marcus.png",
        "images/mark-becs.png",
        "images/mark-fourth-set-mugs.png",
        "images/mark-second-set-mugs.png",
        "images/mark-third-set-mugs.png",
        "images/mark-top-mug.png",
        "images/martin-arm.png",
        "images/martin.png",
        "images/nosheen.png",
        "images/outside.png",
        "images/portrait-bg.jpg",
        "images/rich.png",
        "images/scene-1-full.jpg",
        "images/scene-1-roof.png",
        "images/scene-1-smoke.png",
        "images/scene-1-tracks.png",
        "images/scene-1.png",
        "images/scene-2-full.jpg",
        "images/scene-2.png",
        "images/scene-3-full.jpg",
        "images/scene-3.png",
        "images/scene-4-full.jpg",
        "images/scene-4.png",
        "images/scene-5-filler.png",
        "images/smoke-1.png",
        "images/smoke-2.png",
        "images/smoke.png",
        "images/steve.png",
        "images/teddy.png",
        "images/ticket.png",
        "images/train-bg-engine.jpg",
        "images/train-bg-engine.png",
        "images/train-bg-inside.png",
        "images/train-bg.png",
        "images/white-transparent.png",
        "images/window.png"
    ]).then(function(imgs) {
        document.querySelector('.loading').classList.add('hide');
    }, function(errImg) {
        console.error(errImg);
    });

    // PLAY VIDEO
    $('.play-button a').on('click', function(){
        $('.video-overlay').addClass('active');
        $('.video').get(0).play();
    });

    $('.play-button .play').on('click', function(){
        $('.video-overlay').addClass('active');
        $('.video').get(0).play();
    });

    $('.video-overlay, .video-overlay .close ').on('click', function(){
        $('.video-overlay').removeClass('active');
        $('.video').get(0).pause();
    });

    function documentCalculations () {
        var winWidth = $(window).width();
        var winHeight = $(window).height();

        var engineSceneOneWidth = $('.engine-scene-1-wrap .scene-1').width();
        var engineSceneTwoWidth = $('.engine-scene-2-wrap .scene-2').width();
        var engineSceneThreeWidth = $('.engine-scene-3-wrap .scene-3').width();
        var sceneOneWidth = $('.scene-1-wrap .scene-1').width();
        var sceneTwoWidth = $('.scene-2-wrap .scene-2').width();
        var sceneThreeWidth = $('.scene-3-wrap .scene-3').width();
        var sceneFourWidth = $('.scene-4-wrap .scene-4').width();
        var sceneFiveWidth = $('.scene-5-wrap .scene-5').width();
        var wrapWidth = engineSceneOneWidth + engineSceneTwoWidth + engineSceneThreeWidth + sceneOneWidth + sceneTwoWidth + sceneThreeWidth + sceneFourWidth + sceneFiveWidth;

        var insideWrapWidth = wrapWidth - (engineSceneOneWidth + engineSceneTwoWidth + engineSceneThreeWidth);
        var insideWrapWidth2 = wrapWidth - sceneFiveWidth;

        if (wrapWidth <= winWidth ){
            $('#block').attr('data-1050p', 'left:-0%' );
            $('#background').attr('data-1050p', 'left:-0%' );
        }

        if (wrapWidth > winWidth ){
            // THIS CALCULATES WHERE SCENE 1 NEEDS TO END
            var winOffsetGreaterEnd = ((wrapWidth - winWidth) / winWidth) * 100 ;
            var insideOffset = ((wrapWidth - insideWrapWidth) / winWidth) * 100 ;
            var insideOffsetInner = ((insideWrapWidth2 - winWidth) / winWidth) * 100 ;

            $('#block').width(wrapWidth);
            $('#background').width(wrapWidth);

            $('#block').attr('data-1050p', 'left:-'+ winOffsetGreaterEnd +'%' );
            $('#block').attr('data-1450p', 'left:-'+ insideOffset +'%' );
            $('#block').attr('data-1550p', 'left:-'+ insideOffset +'%' );
            $('#block').attr('data-2675p', 'left:-'+ insideOffsetInner +'%' );

            $('#background').attr('data-1050p', 'left:-'+ winOffsetGreaterEnd +'%' );
            $('#background').attr('data-1450p', 'left:-'+ insideOffset +'%' );
            $('#background').attr('data-1550p', 'left:-'+ insideOffset +'%' );
            $('#background').attr('data-2675p', 'left:-'+ insideOffsetInner +'%' );
        }

        $('.engine-scene-1-wrap').width(engineSceneOneWidth);
        $('.engine-scene-2-wrap').width(engineSceneTwoWidth);
        $('.engine-scene-3-wrap').width(engineSceneThreeWidth);

        $('.scene-1-wrap').width(sceneOneWidth);
        $('.scene-2-wrap').width(sceneTwoWidth);
        $('.scene-3-wrap').width(sceneThreeWidth);
        $('.scene-4-wrap').width(sceneFourWidth);
        $('.scene-5-wrap').width(sceneFiveWidth);
    }

    setTimeout(function(){
        documentCalculations();

        var availableHeight = $(document).height();
        var heightFlag = false;

        var s = skrollr.init({
            mobileCheck: function() {
                //hack - forces mobile version to be off
                return false;
            },
            smoothScrolling: true,
            render: function(data) {
                //console.log(data.maxTop);
                if (!heightFlag) {
                    heightFlag = true;
                    availableHeight += data.maxTop;

                    $('body').height(availableHeight);
                }
            }
        });

        var scrollerWidth = $('#scroller').outerWidth();
        var scrollWidth = $('#scroll-wrapper').outerWidth() - scrollerWidth;

        $("#scroller").on('touchmove touchstart touchend', function(e) {
            e.stopPropagation();
            e.preventDefault();
        });

        $("#scroller").draggable({
            containment: "#scroll-wrapper",
            scroll: false,
            drag: function(e, ui) {
                // What percentage of the scroller have we moved?
                var percent = (ui.position.left / scrollWidth) * 100;

                // Scroll height to position
                $('html, body').scrollTop((percent / 100) * availableHeight);
            },
        });
        $('.start').on('click', function(){
            s.animateTo(0, {
                duration:3000,
                easing: "linear"
           });
        });
    }, 450);

    $(window).resize(function(){
        function elementResize () {
            var winWidth = $(window).width();
            var winHeight = $(window).height();

            var engineSceneOneWidth = $('.engine-scene-1-wrap .scene-1').width();
            var engineSceneTwoWidth = $('.engine-scene-2-wrap .scene-2').width();
            var engineSceneThreeWidth = $('.engine-scene-3-wrap .scene-3').width();
            var sceneOneWidth = $('.scene-1-wrap .scene-1').width();
            var sceneTwoWidth = $('.scene-2-wrap .scene-2').width();
            var sceneThreeWidth = $('.scene-3-wrap .scene-3').width();
            var sceneFourWidth = $('.scene-4-wrap .scene-4').width();
            var sceneFiveWidth = $('.scene-5-wrap .scene-5').width();
            var wrapWidth = engineSceneOneWidth + engineSceneTwoWidth + engineSceneThreeWidth + sceneOneWidth + sceneTwoWidth + sceneThreeWidth + sceneFourWidth + sceneFiveWidth;

            var insideWrapWidth = wrapWidth - (engineSceneOneWidth + engineSceneTwoWidth + engineSceneThreeWidth);
            var insideWrapWidth2 = wrapWidth - sceneFiveWidth;

            if (wrapWidth <= winWidth ){
                skrollr.init().destroy();

                $('#block').attr('data-1050p', 'left:-0%' );
                $('#background').attr('data-1050p', 'left:-0%' );

                var s = skrollr.init({
                    mobileCheck: function() {
                        //hack - forces mobile version to be off
                        return false;
                    },
                    smoothScrolling:true,
                    render: function(data) {
                        //console.log(data.maxTop);
                        if (!heightFlag) {
                            heightFlag = true;
                            availableHeight += data.maxTop;
                            $('body').height(availableHeight);
                        }
                    }
                });
            }

            if (wrapWidth > winWidth ) {
                // THIS CALCULATES WHERE SCENE 1 NEEDS TO END
                var winOffsetGreaterEnd = ((wrapWidth - winWidth) / winWidth) * 100 ;
                var insideOffset = ((wrapWidth - insideWrapWidth) / winWidth) * 100 ;
                var insideOffsetInner = ((insideWrapWidth2 - winWidth) / winWidth) * 100 ;

                skrollr.init().destroy();
                $('#block').width(wrapWidth);
                $('#background').width(wrapWidth);

                $('#block').attr('data-1050p', 'left:-'+ winOffsetGreaterEnd +'%' );
                $('#block').attr('data-1450p', 'left:-'+ insideOffset +'%' );
                $('#block').attr('data-1550p', 'left:-'+ insideOffset +'%' );
                $('#block').attr('data-2675p', 'left:-'+ insideOffsetInner +'%' );

                $('#background').attr('data-1050p', 'left:-'+ winOffsetGreaterEnd +'%' );
                $('#background').attr('data-1450p', 'left:-'+ insideOffset +'%' );
                $('#background').attr('data-1550p', 'left:-'+ insideOffset +'%' );
                $('#background').attr('data-2675p', 'left:-'+ insideOffsetInner +'%' );

                var s = skrollr.init({
                    mobileCheck: function() {
                        //hack - forces mobile version to be off
                        return false;
                    },
                    smoothScrolling: true,
                    render: function(data) {
                        //console.log(data.maxTop);
                        if (!heightFlag) {
                            heightFlag = true;
                            availableHeight += data.maxTop;
                            $('body').height(availableHeight);
                        }
                    }
                });
            }

            $('.engine-scene-1-wrap').width(engineSceneOneWidth);
            $('.engine-scene-2-wrap').width(engineSceneTwoWidth);
            $('.engine-scene-3-wrap').width(engineSceneThreeWidth);

            $('.scene-1-wrap').width(sceneOneWidth);
            $('.scene-2-wrap').width(sceneTwoWidth);
            $('.scene-3-wrap').width(sceneThreeWidth);
            $('.scene-4-wrap').width(sceneFourWidth);
            $('.scene-5-wrap').width(sceneFiveWidth);
        }

        elementResize();

        var availableHeight = $(window).height();

        var heightFlag = false;

        var scrollerWidth = $('#scroller').outerWidth();
        var scrollWidth = $('#scroll-wrapper').outerWidth() - scrollerWidth;

        $("#scroller").on('touchmove touchstart touchend', function(e) {
            e.stopPropagation();
            e.preventDefault();
        });

        $('.preview-container #scroll-wrapper #scroller').css('left', '0px');

        $("#scroller").draggable({
            containment: "#scroll-wrapper",
            scroll: false,
            drag: function(e, ui) {
                // What percentage of the scroller have we moved?
                var percent = (ui.position.left / scrollWidth) * 100;

                // Scroll height to position
                $('html, body').scrollTop((percent / 100) * availableHeight);
            },
        });
    });

    $(window).scroll(function(){
        var distanceScrolled = $(document).scrollTop();
        var bodyHeight = $('body').height();
        var percentScrolled = (distanceScrolled / bodyHeight ) * 100;

        var scrollerWidth = $('#scroller').outerWidth();
        var scrollWidth = $('#scroll-wrapper').outerWidth();
        var scrollerWidthPercent = (scrollerWidth / scrollWidth) * 100;

        if (percentScrolled == 0) {
            $('.preview-container #scroll-wrapper #scroller').css('left', '0%');
        } else if (percentScrolled >= 1.68) {
            $('.preview-container #scroll-wrapper #scroller').css('left', percentScrolled - 1.68+  '%');
        }
    });
});

},{}]},{},[1]);
